import api from 'api'
import { ExternalCourseCertificate } from 'models/externalCourseCertificate.model'

export interface GetListResponse {
  data: ExternalCourseCertificate[]
}

const list = () => {
  return api
    .get('/external_courses_certificates')
    .then<GetListResponse>(({ data }) => {
      return {
        data: data.data.map(({ attributes }: any) => attributes),
      }
    })
}

export default list
